import { MessageCircle, Gift, MapPin, Clock, Sparkles, Users } from "lucide-react";
import Reveal from "@/components/Reveal";
import { Link } from "react-router-dom";

const WHATSAPP_URL =
  "https://wa.me/18696686713?text=Hi%20Sugar%20Town%20Organics!%20I'd%20like%20to%20place%20a%20quick%20order.";

const PreFooterConversion = () => {
  return (
    <section
      aria-labelledby="prefooter-heading"
      className="relative py-[60px] md:py-[90px]"
      style={{ backgroundColor: "#f1e9dc" }}
    >
      <div className="container mx-auto px-6" style={{ maxWidth: "1300px" }}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left — final conversion copy */}
          <Reveal>
            <p className="text-[11px] tracking-[0.32em] uppercase font-sans text-accent/90 mb-5">
              Plan a Visit or Send a Gift
            </p>
            <h2
              id="prefooter-heading"
              className="font-serif text-[2.2rem] sm:text-[2.7rem] md:text-[3.3rem] leading-[1.05] tracking-[-0.01em] text-foreground mb-6"
            >
              Experience Sugar Town Organics <em className="not-italic text-primary">Beyond The Screen</em>
            </h2>
            <p className="font-sans text-base md:text-[1.05rem] leading-relaxed text-muted-foreground mb-8 max-w-xl">
              Whether you're visiting St. Kitts, sending a thoughtful island
              gift abroad, or placing a quick local WhatsApp order, our
              handcrafted collections are always within reach.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-7 py-4 rounded-full font-sans font-medium text-[12px] uppercase tracking-[0.22em] hover:bg-primary/90 hover:-translate-y-0.5 transition-all shadow-[0_14px_34px_-14px_rgba(60,90,60,0.55)]"
              >
                <MessageCircle className="w-4 h-4" />
                WhatsApp Quick Order
              </a>
              <Link
                to="/shop?category=gift-boxes"
                className="inline-flex items-center justify-center gap-2 border-2 border-primary text-primary bg-transparent px-7 py-4 rounded-full font-sans font-medium text-[12px] uppercase tracking-[0.22em] hover:bg-primary hover:text-primary-foreground transition-all"
              >
                <Gift className="w-4 h-4" />
                Browse Island Gifts
              </Link>
            </div>
          </Reveal>

          {/* Right — stacked concierge cards */}
          <div className="space-y-4 md:space-y-5">
            {[
              {
                icon: MapPin,
                title: "Visit Di Organics Shoppe",
                line: "Shadwell Great House, St. Kitts",
                body: "Island-made gifts, wellness products, local treats & curated experiences.",
              },
              {
                icon: Clock,
                title: "Open For In-Person Shopping",
                line: "Monday – Saturday · 10am – 5pm",
                body: "Local pickup, walk-in browsing and Balm & Bond bookings available.",
              },
              {
                icon: Sparkles,
                title: "Wholesale & Hotel Amenities",
                line: "Curated Caribbean Gifting",
                body: "For villas, hotels, retreats and corporate events across the region.",
              },
              {
                icon: Users,
                title: "Book Us For Your Group Marketplace",
                line: "Curated Shopping Pop-Up",
                body: "For groups, corporate, marketplaces and staff retreats — a curated Sugar Town Organics shopping experience brought to you.",
              },
            ].map((card, i) => (
              <Reveal key={i} delay={i * 90}>
                <div className="group bg-[#fdfaf3] rounded-2xl p-6 md:p-7 shadow-[0_14px_36px_-22px_rgba(60,40,15,0.25)] border border-[hsl(var(--border))] hover:shadow-[0_22px_50px_-22px_rgba(60,40,15,0.35)] hover:-translate-y-0.5 transition-all">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-11 h-11 rounded-full bg-accent/15 flex items-center justify-center">
                      <card.icon className="w-5 h-5 text-accent" />
                    </div>
                    <div>
                      <h3 className="font-serif text-lg md:text-xl text-foreground leading-tight mb-1">
                        {card.title}
                      </h3>
                      <p className="text-[11px] tracking-[0.22em] uppercase font-sans text-primary/80 mb-2">
                        {card.line}
                      </p>
                      <p className="font-sans text-sm leading-relaxed text-muted-foreground">
                        {card.body}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
      {/* Subtle gold botanical divider closing the section */}
      <div
        aria-hidden
        className="mx-auto mt-16 md:mt-20 h-px w-[min(560px,80%)]"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, hsl(40 55% 50% / 0.55) 50%, transparent 100%)",
        }}
      />
    </section>
  );
};

export default PreFooterConversion;
